const SvgIconCheck = (props) => {
  const {
    width = 24,
    height = 24,
    enableViewBox = true,
    iconFillColor = "fill-[#FFF]",
    outerFillColor = "fill-none",
    onClickCallback,
    iconStyle,
    style,
    ...otherProps
  } = props;
  return (
    <svg
      className={`${iconStyle} ${style}`}
      width={width}
      height={height}
      {...(enableViewBox && { viewBox: `0 0 ${width} ${height}` })}
      onClick={onClickCallback}
      {...otherProps}
    >
      <g className={outerFillColor} fillRule="evenodd">
        <path d="M2 2h20v20H2z" />
        <path
          d="M9.098 19.038l-5.88-5.88a.905.905 0 010-1.28l1.279-1.28a.905.905 0 011.28 0l3.961 3.962 8.486-8.485a.905.905 0 011.28 0l1.279 1.279a.905.905 0 010 1.28L10.378 19.038a.905.905 0 01-1.28 0z"
          className={iconFillColor}
        />
      </g>
    </svg>
  );
};

export default SvgIconCheck;
